"use strict";

//var $ = require('../lib/jquery');
//var Emitter = require('events');
var Emitter = require('events').EventEmitter;

var casefactory = require('./casefactory');

var React = require('react');
//var ReactDom = require('../lib/reactDom');
var ReactDom = require('react-dom');

//import ReactDom from 'react-dom';

var Choices = window.ThomannCasefactory_ui.getChoices();
//var Infos = require('./components/Infos.jsx');

var debounce = require('debounce');

import Provider from '../components/Provider.jsx';

import CaseInfoBox from '../components/UI/CaseInfoBox';

var {
    changeElementInCaseWorld,
    scaleCaseDimensionTo,
    updateKeyboard,
    addRollsOrFeeds,
    removeRollsOrFeeds,
    deactivateOption,
    activateOption,
    scaleCaseDimensionToAndRequestUpdates
} = casefactory.action;

var isCmMode = true;

module.exports = {
    bootstrap: function () {
        var currentData = casefactory.getData();
        var caseWorldController = casefactory.getCaseWorldController();
        var userIsDragging = false;
        var emitter = new Emitter();
        var basePath = casefactory.getBasePath();

        currentData.isCmMode = isCmMode;
        renderCasefactoryUi(currentData);
        caseWorldController.on('init', setupUiEventListener);

        function renderCasefactoryUi(data) {
            currentData = data;
            updateNonReactComponents(data);
            updateCaseInfoBox(data);
            ReactDom.render(
                <Provider emitter={emitter}>
                    <Choices
                        basePath = {basePath}
                        {...data}
                        location={window.location}
                    />
                </Provider>, $('.lr-casefactory-choices-react').get(0));
        }

        function updateNonReactComponents( data ) {

            // variables
            let summary       = $( '#content .product .product-summary' );
            let price         = summary.find( '.price' );
            let cart          = summary.find( 'form.cart' );
            let caseIdElement = cart.find( '.megacase_case_id' );

            if ( data.case.hasOwnProperty( 'casePrice' ) ) {
                // use case price (incl. tax) html
                price.html( data.case.casePrice )
            }
            else {
                // use net price and add standard de tax, always round down
                let grossPrice = Math.floor( data.case.netPrice * 1.19 );

                // show with 2 digits after comma
                let currentPrice = parseFloat( grossPrice ).toFixed(2);

                // format price
                let formattedPrice = currentPrice.replace( '.', ',');

                // gets content, filter for first text, replace with new price
                price.find( '.amount' ).contents().filter(function(){ return this.nodeType === 3; }).first().replaceWith( formattedPrice + ' ' );
            }

            if (data.case.isVirtualCase) {
                cart.addClass('virtualCase');
            } else {
                cart.removeClass('virtualCase');
            }

            // save the case id to hidden add-to-cart form field
            caseIdElement.val( data.case.id );
        }

        function updateCaseInfoBox( data ) {
            ReactDom.render(
                <CaseInfoBox data={data} />,
                document.getElementById('case-info')
            );
        }

        let renderUiAndUpdateCaseWorldDebounced = debounce(function (dimension, value) {
            renderCasefactoryUi(currentData);
            caseWorldController.startAction();
            scaleCaseDimensionTo(dimension, value);
            caseWorldController.endAction();
        }, 6);

        function setupUiEventListener() {
            emitter.on('dimensionChange', (dimension, value) => {
                userIsDragging = false;
                currentData.case.dimensions.interior[dimension] = value;

                if(dimension=="height_unit"){
                    currentData.case.dimensions.interior["height"] = value*45;
                }

                renderCasefactoryUi(currentData);
                scaleCaseDimensionToAndRequestUpdates(dimension, value, null);
            });

            emitter.on('dimensionDrag', (dimension, value) => {
                userIsDragging = true;
                currentData.case.dimensions.interior[dimension] = value;
                renderUiAndUpdateCaseWorldDebounced(dimension, value);
            });

            emitter.on('keyboard', (keyboardId) => {
                currentData.case.keyboardId = keyboardId;
                currentData.case.keyboardBrandAndModel = null;
                renderCasefactoryUi(currentData);
                if (keyboardId) {
                    updateKeyboard(keyboardId, '');
                }
            });
            emitter.on('manufacturer', (manufacturer) => {
                currentData.case.keyboardBrandAndModel = null;
                currentData.case.keyboardId = null;
                currentData.case.keyboardManufacturer = manufacturer;
                renderCasefactoryUi(currentData);

                if (!manufacturer) {
                    updateKeyboard(-1, '');
                }
            });

            emitter.on('keyboardBrandAndModel', (keyboardBrandAndModel) => {
                currentData.case.keyboardId = null;
                currentData.case.keyboardManufacturer = null;
                currentData.case.keyboardBrandAndModel = keyboardBrandAndModel;
                updateKeyboard(-1, keyboardBrandAndModel);

                renderCasefactoryUi(currentData);
            });

            // called on typing, no update to server
            emitter.on('keyboardBrandAndModelChange', (keyboardBrandAndModel) => {
                currentData.case.keyboardId = null;
                currentData.case.keyboardManufacturer = null;
                currentData.case.keyboardBrandAndModel = keyboardBrandAndModel;

                renderCasefactoryUi(currentData);
            });
            emitter.on('option', (option, value) => {
                if (!value) {
                    currentData.case.options.push(option);
                    renderCasefactoryUi(currentData);
                    activateOption(option);
                } else {
                    var index = currentData.case.options.indexOf(option);
                    currentData.case.options.splice(index, 1);
                    renderCasefactoryUi(currentData);
                    deactivateOption(option);
                }
            });
            emitter.on('foam', (foamId) => {
                currentData.case.FOAM = foamId;
                renderCasefactoryUi(currentData);
                changeElementInCaseWorld(foamId, 'FOAM', null, null, null, null, true, true);
            });
            emitter.on('handle', (part) => {
                currentData.case.HANDLE = part.id;
                renderCasefactoryUi(currentData);
                changeElementInCaseWorld(part.id, part.category, null, null, null, null, true, true);
            });
            emitter.on('fastener', (part) => {
                currentData.case.FASTENER = part.id;
                renderCasefactoryUi(currentData);
                changeElementInCaseWorld(part.id, part.category, null, null, null, null, true, true);
            });
            emitter.on('corners', (part) => {
                currentData.case.CORNER = part.id;
                renderCasefactoryUi(currentData);
                changeElementInCaseWorld(part.id, part.category, null, null, null, null, true, true);
            });

            emitter.on('unitMode', (unit) => {
                isCmMode = unit == 'cm';
                currentData.isCmMode = isCmMode;
                renderCasefactoryUi(currentData);
            });

            emitter.on('rollsOrWheels', (wheel) => {
                if (wheel) {
                    currentData.case.WHEEL = wheel.id;
                    renderCasefactoryUi(currentData);
                    addRollsOrFeeds(wheel);
                } else {
                    currentData.case.WHEEL = null;
                    renderCasefactoryUi(currentData);
                    removeRollsOrFeeds({category: 'WHEEL'});
                }
            });

            emitter.on('color', (color) => {
                currentData.case.PANEL = color.id;
                renderCasefactoryUi(currentData);
                changeElementInCaseWorld(color.id, color.category, color.file, color.textureFile, color.normalMaps, null, true, false);
            });

            emitter.on('part', (part, value) => {
                if (!value) {
                    currentData.case.accessories[part.category] = part.id;

                    renderCasefactoryUi(currentData);
                    changeElementInCaseWorld(part.id, part.category, part.file, part.textureFile, part.normalMaps, !value, true, false);
                } else {
                    currentData.case.accessories[part.category] = null;

                    renderCasefactoryUi(currentData);
                    changeElementInCaseWorld(null, part.category, null, null, null, !value, true, false);
                }
            });

            caseWorldController.on('caseUpdated', (newData) => {
                // this changes possible parts which change depending on dimensions
                newData.isCmMode = isCmMode;
                currentData = newData;
                if(!userIsDragging)
                renderCasefactoryUi(currentData);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./js/caseconfigurator/casefactory/configurator.js